import React from "react";
import { Typography, Chip } from "@mui/material";
import { IconPencil, IconTrash } from "../../../../utils/icons";
import classNames from "classnames";

const ContentChannelsList = ({ channels = [], onEdit, onDelete, loading }) => {
  return (
    <div className="flex flex-col">
      {channels.map((channel) => (
        <div
          key={channel.id}
          className={classNames(
            "py-4 px-4 flex items-center justify-between gap-3 border-b border-border-token",
            "hover:bg-surface-2 transition-colors bg-surface"
          )}
        >
          <div className="flex flex-col gap-1 min-w-0 flex-1">
            <div className="flex gap-2 mt-1 items-center flex-wrap">
              <Typography
                variant="subtitle1"
                fontWeight={600}
                className="capitalize"
              >
                {channel.name || "Unnamed Channel"}
              </Typography>
              {Array.isArray(channel.content_types) && (
                <Chip
                  label={`${channel.content_types.length} content type${
                    channel.content_types.length !== 1 ? "s" : ""
                  }`}
                  className="!text-accent-text !border-accent !bg-tint !text-[10px] !px-[0.5px] !py-0 !h-[20px] !rounded-full"
                  variant="outlined"
                  size="small"
                />
              )}
            </div>
          </div>

          <div className="flex gap-2 items-center">
            {onEdit && (
              <div
                className="p-1 rounded-md cursor-pointer bg-surface border border-transparent hover:bg-surface-2 hover:border-muted"
                title="Edit"
                onClick={() => onEdit(channel)}
              >
                <IconPencil stroke="#C6C6C6" size={18} />
              </div>
            )}
            {onDelete && (
              <div
                className="p-1 rounded-md cursor-pointer bg-surface border border-transparent hover:bg-surface-2 hover:border-muted"
                title="Delete"
                onClick={() => onDelete(channel)}
              >
                <IconTrash stroke="#C6C6C6" width={18} height={18} />
              </div>
            )}
          </div>
        </div>
      ))}
      {!loading && channels.length === 0 && (
        <div className="py-8 text-center">
          <Typography color="textSecondary">No channels found.</Typography>
        </div>
      )}
    </div>
  );
};

export default ContentChannelsList;
